import { render, staticRenderFns } from "./RemoteManagementAndroid.vue?vue&type=template&id=4ecc767e&"
import script from "./RemoteManagementAndroid.vue?vue&type=script&lang=ts&"
export * from "./RemoteManagementAndroid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ecc767e')) {
      api.createRecord('4ecc767e', component.options)
    } else {
      api.reload('4ecc767e', component.options)
    }
    module.hot.accept("./RemoteManagementAndroid.vue?vue&type=template&id=4ecc767e&", function () {
      api.rerender('4ecc767e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/rooms/RemoteManagementAndroid.vue"
export default component.exports